import React from 'react';
import { Icon } from '@iconify/react';

interface StatCardProps {
  label: string;
  value: string;
  icon: string;
  iconBg?: string;
  iconColor?: string;
  trend?: string;
  trendUp?: boolean;
}

const StatCard: React.FC<StatCardProps> = ({
  label,
  value,
  icon,
  iconBg = 'rgba(13, 148, 136, 0.12)',
  iconColor = '#14B8A6',
  trend,
  trendUp,
}) => {
  return (
    <div style={{
      background: 'var(--glass-bg)',
      backdropFilter: 'var(--glass-blur)',
      WebkitBackdropFilter: 'var(--glass-blur)',
      border: '1px solid var(--glass-border)',
      borderRadius: 'var(--radius-lg)',
      padding: '20px 24px',
      display: 'flex',
      alignItems: 'flex-start',
      gap: '16px',
      transition: 'all var(--transition-base)',
    }}>
      <div style={{
        width: '44px',
        height: '44px',
        borderRadius: '12px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: iconBg,
        color: iconColor,
        flexShrink: 0,
      }}>
        <Icon icon={icon} width={22} />
      </div>
      <div>
        <div style={{ fontSize: '13px', color: 'var(--text-muted)', fontWeight: 500, marginBottom: '4px' }}>
          {label}
        </div>
        <div style={{
          fontFamily: 'var(--font-heading)',
          fontSize: '24px',
          fontWeight: 700,
          color: 'var(--text-primary)',
        }}>
          {value}
        </div>
        {trend && (
          <div style={{
            fontSize: '12px',
            fontWeight: 600,
            marginTop: '4px',
            color: trendUp ? 'var(--success)' : 'var(--danger)',
            display: 'flex',
            alignItems: 'center',
            gap: '4px',
          }}>
            <Icon icon={trendUp ? 'solar:arrow-up-bold' : 'solar:arrow-down-bold'} width={12} />
            {trend}
          </div>
        )}
      </div>
    </div>
  );
};

export default StatCard;
